import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import { useState } from "react";
import ConfirmToast from "../universal/ConfirmToast";
import { confirmAlert } from "react-confirm-alert";
import { format } from "date-fns";
import { JOURNAL_NOTE_ITEM_TYPES } from "../../constants/Common";
import AudioCard from "./AudioCard";

const NotePreviewCard = ({
  note,
  journalValues,
  index,
  setCurrNotesIndex,
  setIsNotesEdit,
  setCurrNotes,
  setShowNotesBox,
  handleDeleteNotes,
}) => {
  const noteItem = note?.noteitems?.[0];
  return (
    <div className="relative flex flex-col gap-3 rounded-lg border border-white border-opacity-25 bg-black bg-opacity-30 p-4">
      <div className="absolute -left-[30px] top-1 h-3 w-3 -translate-y-1/2 rounded-full border-2 border-white bg-yellowish"></div>
      <div className="cursor-pointer">
        <div className="flex justify-between">
          {noteItem?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VIDEO && (
            <video
              src={noteItem?.url_link}
              controls={true}
              className="aspect-video w-5/12 overflow-hidden rounded-md object-cover"
            ></video>
          )}
          {noteItem?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.IMAGE && (
            <img
              src={noteItem?.url_link}
              controls={true}
              className="aspect-video w-5/12 overflow-hidden rounded-md object-cover"
              alt=""
            />
          )}
          {noteItem?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.TEXT && (
            <p
              className="font-white w-9/12 text-sm font-medium text-white line-clamp-5 overflow-hidden overflow-ellipsis"
              dangerouslySetInnerHTML={{ __html: noteItem?.notes ?? "--" }}
            ></p>
          )}
          {noteItem?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.AUDIO && (
            <AudioCard url={noteItem?.url_link} />
          )}
          {noteItem?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VERSE && (
            <div className="group relative flex flex-col flex-wrap gap-3 text-white">
              <h3 className="text-2xl font-semibold">
                {noteItem?.bookname}{" "}
                <span>
                  {noteItem?.chapterid}:{noteItem?.verse_start}
                </span>
              </h3>
              <p>{noteItem?.notes}</p>
            </div>
          )}
          <div className="flex cursor-pointer items-center justify-end gap-2">
            <span className="mr-8 text-greyish">
              {note?.lastUpdatedDate && format(note?.lastUpdatedDate, "dd MMM yyyy")}
            </span>
            <img
              className="h-4"
              src={edit}
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                setCurrNotes(note);
                setShowNotesBox(true);
                setCurrNotesIndex(index);
                setIsNotesEdit(true);
              }}
            />
            <img
              className="mr-4 h-4"
              src={close}
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNotes({
                  noteObjId: note?.noteObjId,
                  notesIndex: index,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotePreviewCard;
